import parsePhoneNumber, { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import { isNil, isString } from 'lodash-es';

export const toPhone = (val?: string, region: CountryCode = 'US'): string => {
  if (!isString(val) || isNil(val)) {
    return '';
  }

  const phoneNumber = parsePhoneNumber(val, region);

  if (!isValidPhoneNumber(val, region) || !phoneNumber) {
    return val;
  }

  return `+${phoneNumber.countryCallingCode} ${phoneNumber.formatNational()}`;
};
